import createAction from './_createAction';

export const HIDE_SECOND_MODAL = createAction('HIDE_SECOND_MODAL');
